module.exports = __webpack_public_path__ + "img/questionnaire-orange-circles.89093c2d.svg";